function BackButton({ onClick }) {
    return (
        <button
            onClick={onClick}
            style={{ background: "none", border: "none", borderRadius: "50%", margin: "0 .675rem", padding: "0" }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                viewBox="0 0 36 36"
            >
                <g
                    id="Group_3037"
                    data-name="Group 3037"
                    transform="translate(-325 -110.667)"
                >
                    <rect
                        id="Rectangle_6204"
                        data-name="Rectangle 6204"
                        width="36"
                        height="36"
                        rx="18"
                        transform="translate(325 110.667)"
                        fill="#f4ebfb"
                    />
                    <g
                        id="arrow_back_black_24dp_2_"
                        data-name="arrow_back_black_24dp (2)"
                        transform="translate(331 116.667)"
                    >
                        <path
                            id="Path_603"
                            data-name="Path 603"
                            d="M0,0H24V24H0Z"
                            fill="none"
                        />
                        <path
                            id="Path_604"
                            data-name="Path 604"
                            d="M20,11H7.83l5.59-5.59L12,4,4,12l8,8,1.41-1.41L7.83,13H20Z"
                            fill="#2A1FB3"
                        />
                    </g>
                </g>
            </svg>
        </button>
    );
}

export default BackButton;
